import { useTranslations } from 'next-intl';
import Image from 'next/image';
import QueryLink from '@components/QueryLink';
import BgContainerBig from '@components/BgContainerBig';
import getOption from '@/src/utils/getOption';
import Link from 'next-intl/link';

export default function BannerFrontBottomFixed() {
  const t = useTranslations('Banners.BannerFrontBottomFixed');
  return (
    <BgContainerBig>
      <div className='relative z-10 my-6 flex max-w-[800px] flex-wrap items-center justify-center gap-12 xs:flex-nowrap lg:gap-20 xl:gap-32'>
        <Image
          src='/images/icon-auction2.svg'
          alt=''
          width={150}
          height={150}
          className='h-auto w-[100px] xs:w-[120px] md:w-[150px] lg:w-[250px]'
        />
        <div className='flex flex-col gap-4'>
          <span className='uppercase'>{t('title')}</span>
          <h2 className='mb-2 text-3xl font-semibold'>
            {t.rich('content', {
              b: (chunks) => <b className='text-brand'>{chunks}</b>,
            })}
          </h2>
          <div className='text-right'>
            <Link
              href={String(getOption('SIBLING_SITE_URL'))}
              target='_blank'
              className='inline-flex gap-2 border border-brand bg-brand px-4 py-2 font-semibold uppercase text-dark transition-all hover:bg-transparent hover:text-white'
            >
              {t('button')}
              <Image
                src='/images/icon-auction.svg'
                alt=''
                width={20}
                height={20}
              />
            </Link>
          </div>
        </div>
      </div>
    </BgContainerBig>
  );
}
